import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-date label-mono-2xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "dash" }, "#", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.date), 1)
  ]))
}